import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createNewsRequest,
  getNews,
  removeNews,
  updateNewsRequest,
} from "../../../../services/api/landing/news/newsApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  add: { en: "News created successfully!", ar: "تم إنشاء الخبر بنجاح!" },
  addError: { en: "Failed to create news.", ar: "فشل في إنشاء الخبر." },
  update: { en: "News updated successfully!", ar: "تم تحديث الخبر بنجاح!" },
  updateError: { en: "Failed to update news.", ar: "فشل في تحديث الخبر." },
  delete: { en: "News deleted successfully!", ar: "تم حذف الخبر بنجاح!" },
  deleteError: { en: "Failed to delete news.", ar: "فشل في حذف الخبر." },
};

export const fetchNews = createAsyncThunk(
  "news/fetchNews",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getNews();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch news");
    }
  },
);

export const createNews = createAsyncThunk(
  "news/createNews",
  async (newsData, { rejectWithValue }) => {
    try {
      const response = await createNewsRequest(newsData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to create news");
    }
  },
);

export const updateNews = createAsyncThunk(
  "news/updateNews",
  async ({ newsId, updatedData }, { rejectWithValue }) => {
    try {
      const response = await updateNewsRequest(newsId, updatedData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update news");
    }
  },
);

export const deleteNews = createAsyncThunk(
  "news/deleteNews",
  async (newsId, { rejectWithValue }) => {
    try {
      await removeNews(newsId);
      return newsId;
    } catch (error) {
      return rejectWithValue("Failed to delete news");
    }
  },
);

const newsSlice = createSlice({
  name: "news",
  initialState: {
    newsData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNews.fulfilled, (state, action) => {
        state.loading = false;
        state.newsData = action.payload;
      })
      .addCase(fetchNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createNews.fulfilled, (state, action) => {
        state.newsData.push(action.payload);
        toast.success(toastMessages.add[getLang()]);
      })
      .addCase(createNews.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.addError[getLang()]);
      })
      .addCase(updateNews.fulfilled, (state, action) => {
        const index = state.newsData.findIndex(
          (news) => news.id === action.payload.id,
        );
        if (index !== -1) {
          state.newsData[index] = action.payload;
        }
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateNews.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      })
      .addCase(deleteNews.fulfilled, (state, action) => {
        state.newsData = state.newsData.filter(
          (news) => news.id !== action.payload,
        );
        toast.success(toastMessages.delete[getLang()]);
      })
      .addCase(deleteNews.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.deleteError[getLang()]);
      });
  },
});

export default newsSlice.reducer;
